// API calls are now handled in sagas, not in actions

// Action Types
export const RAG_ACTION_TYPES = {
  // Process Document
  PROCESS_DOCUMENT_REQUEST: "PROCESS_DOCUMENT_REQUEST",
  PROCESS_DOCUMENT_SUCCESS: "PROCESS_DOCUMENT_SUCCESS",
  PROCESS_DOCUMENT_FAILURE: "PROCESS_DOCUMENT_FAILURE",

  // Query RAG
  QUERY_RAG_REQUEST: "QUERY_RAG_REQUEST",
  QUERY_RAG_SUCCESS: "QUERY_RAG_SUCCESS",
  QUERY_RAG_FAILURE: "QUERY_RAG_FAILURE",

  // Get Document
  GET_DOCUMENT_REQUEST: "GET_DOCUMENT_REQUEST",
  GET_DOCUMENT_SUCCESS: "GET_DOCUMENT_SUCCESS",
  GET_DOCUMENT_FAILURE: "GET_DOCUMENT_FAILURE",

  // List Documents
  LIST_DOCUMENTS_REQUEST: "LIST_DOCUMENTS_REQUEST",
  LIST_DOCUMENTS_SUCCESS: "LIST_DOCUMENTS_SUCCESS",
  LIST_DOCUMENTS_FAILURE: "LIST_DOCUMENTS_FAILURE",

  // Get Document Chunks
  GET_DOCUMENT_CHUNKS_REQUEST: "GET_DOCUMENT_CHUNKS_REQUEST",
  GET_DOCUMENT_CHUNKS_SUCCESS: "GET_DOCUMENT_CHUNKS_SUCCESS",
  GET_DOCUMENT_CHUNKS_FAILURE: "GET_DOCUMENT_CHUNKS_FAILURE",

  // Get RAG Stats
  GET_RAG_STATS_REQUEST: "GET_RAG_STATS_REQUEST",
  GET_RAG_STATS_SUCCESS: "GET_RAG_STATS_SUCCESS",
  GET_RAG_STATS_FAILURE: "GET_RAG_STATS_FAILURE",

  // Update Document
  UPDATE_DOCUMENT_REQUEST: "UPDATE_DOCUMENT_REQUEST",
  UPDATE_DOCUMENT_SUCCESS: "UPDATE_DOCUMENT_SUCCESS",
  UPDATE_DOCUMENT_FAILURE: "UPDATE_DOCUMENT_FAILURE",

  // Delete Document
  DELETE_DOCUMENT_REQUEST: "DELETE_DOCUMENT_REQUEST",
  DELETE_DOCUMENT_SUCCESS: "DELETE_DOCUMENT_SUCCESS",
  DELETE_DOCUMENT_FAILURE: "DELETE_DOCUMENT_FAILURE",

  // Clear States
  CLEAR_RAG_DATA: "CLEAR_RAG_DATA",
  CLEAR_RAG_ERROR: "CLEAR_RAG_ERROR",
};

// Action Creators
export const processDocumentRequest = (input) => ({
  type: RAG_ACTION_TYPES.PROCESS_DOCUMENT_REQUEST,
  payload: input,
});

export const processDocumentSuccess = (data) => ({
  type: RAG_ACTION_TYPES.PROCESS_DOCUMENT_SUCCESS,
  payload: data,
});

export const processDocumentFailure = (error) => ({
  type: RAG_ACTION_TYPES.PROCESS_DOCUMENT_FAILURE,
  payload: error,
});

export const queryRAGRequest = (input) => ({
  type: RAG_ACTION_TYPES.QUERY_RAG_REQUEST,
  payload: input,
});

export const queryRAGSuccess = (data) => ({
  type: RAG_ACTION_TYPES.QUERY_RAG_SUCCESS,
  payload: data,
});

export const queryRAGFailure = (error) => ({
  type: RAG_ACTION_TYPES.QUERY_RAG_FAILURE,
  payload: error,
});

export const getDocumentRequest = (documentId, tenantId) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_REQUEST,
  payload: { documentId, tenantId },
});

export const getDocumentSuccess = (data) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_SUCCESS,
  payload: data,
});

export const getDocumentFailure = (error) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_FAILURE,
  payload: error,
});

export const listDocumentsRequest = (tenantId, status, limit) => ({
  type: RAG_ACTION_TYPES.LIST_DOCUMENTS_REQUEST,
  payload: { tenantId, status, limit },
});

export const listDocumentsSuccess = (data) => ({
  type: RAG_ACTION_TYPES.LIST_DOCUMENTS_SUCCESS,
  payload: data,
});

export const listDocumentsFailure = (error) => ({
  type: RAG_ACTION_TYPES.LIST_DOCUMENTS_FAILURE,
  payload: error,
});

export const getDocumentChunksRequest = (documentId, tenantId) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_REQUEST,
  payload: { documentId, tenantId },
});

export const getDocumentChunksSuccess = (data) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_SUCCESS,
  payload: data,
});

export const getDocumentChunksFailure = (error) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_FAILURE,
  payload: error,
});

export const getRAGStatsRequest = (tenantId) => ({
  type: RAG_ACTION_TYPES.GET_RAG_STATS_REQUEST,
  payload: { tenantId },
});

export const getRAGStatsSuccess = (data) => ({
  type: RAG_ACTION_TYPES.GET_RAG_STATS_SUCCESS,
  payload: data,
});

export const getRAGStatsFailure = (error) => ({
  type: RAG_ACTION_TYPES.GET_RAG_STATS_FAILURE,
  payload: error,
});

export const updateDocumentRequest = (input) => ({
  type: RAG_ACTION_TYPES.UPDATE_DOCUMENT_REQUEST,
  payload: input,
});

export const updateDocumentSuccess = (data) => ({
  type: RAG_ACTION_TYPES.UPDATE_DOCUMENT_SUCCESS,
  payload: data,
});

export const updateDocumentFailure = (error) => ({
  type: RAG_ACTION_TYPES.UPDATE_DOCUMENT_FAILURE,
  payload: error,
});

export const deleteDocumentRequest = (documentId, tenantId) => ({
  type: RAG_ACTION_TYPES.DELETE_DOCUMENT_REQUEST,
  payload: { documentId, tenantId },
});

export const deleteDocumentSuccess = (data) => ({
  type: RAG_ACTION_TYPES.DELETE_DOCUMENT_SUCCESS,
  payload: data,
});

export const deleteDocumentFailure = (error) => ({
  type: RAG_ACTION_TYPES.DELETE_DOCUMENT_FAILURE,
  payload: error,
});

export const clearRAGData = () => ({
  type: RAG_ACTION_TYPES.CLEAR_RAG_DATA,
});

export const clearRAGError = () => ({
  type: RAG_ACTION_TYPES.CLEAR_RAG_ERROR,
});

// Action Creators (for saga-based approach)
export const processDocument = (input) => ({
  type: RAG_ACTION_TYPES.PROCESS_DOCUMENT_REQUEST,
  payload: input,
});

export const queryRAG = (input) => ({
  type: RAG_ACTION_TYPES.QUERY_RAG_REQUEST,
  payload: input,
});

export const getDocument = (documentId, tenantId) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_REQUEST,
  payload: { documentId, tenantId },
});

export const listDocuments = (tenantId, status, limit) => ({
  type: RAG_ACTION_TYPES.LIST_DOCUMENTS_REQUEST,
  payload: { tenantId, status, limit },
});

export const getDocumentChunks = (documentId, tenantId) => ({
  type: RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_REQUEST,
  payload: { documentId, tenantId },
});

export const getRAGStats = (tenantId) => ({
  type: RAG_ACTION_TYPES.GET_RAG_STATS_REQUEST,
  payload: { tenantId },
});

export const updateDocument = (input) => ({
  type: RAG_ACTION_TYPES.UPDATE_DOCUMENT_REQUEST,
  payload: input,
});

export const deleteDocument = (documentId, tenantId) => ({
  type: RAG_ACTION_TYPES.DELETE_DOCUMENT_REQUEST,
  payload: { documentId, tenantId },
});
